module.exports = __webpack_public_path__ + "static/media/team-award.32dc3928.png";